import React from 'react';
import "../../css/cards/Benefit.css"

const Benefit = ({title, body}) => {
    return (
        <div className="Benefit">
            <div className="benefit-header">{title}:</div>
            <div className="benefit-body">{body}</div>
        </div>
    );
};

export default Benefit;
